(function(){
'use strict';

angular.module('classy').component('typeaheadDropdownControl', {
  template: '\n    <div ng-class="{\'typeahead_is-loading\': $ctrl.loadingItems}">\n      <div class="typeahead_input-dropdown" ng-class="{ \'typeahead-show-groups\': $ctrl.showGroupNames }">\n        <input\n          uib-typeahead="item as item.name for item in $ctrl.executeFetchAction($viewValue)"\n          typeahead-loading="$ctrl.loadingItems"\n          typeahead-no-results="$ctrl.noResults"\n          typeahead-is-open="$ctrl.isOpen"\n          typeahead-on-select="$ctrl.itemSelected($item, $model, $label)"\n          typeahead-min-length="0"\n          typeahead-focus-on-select="false"\n          typeahead-editable="$ctrl.noResults"\n          typeahead-popup-template-url="global/components/controls/typeaheadDropdownControlPopup"\n          autocomplete="{{$ctrl.autofillValue}}"\n          ng-model="$ctrl.selected"\n          ng-model-options="$ctrl.typeaheadOptions"\n          class="typeahead_input"\n          placeholder="{{ $ctrl.selectedItem.label }}"\n          type="text"\n          ng-disabled="{{ $ctrl.disableFlag }}"\n          role="combobox"\n          aria-label="Program Designation"\n        >\n        <div class="typeahead_arrow-overlay" ng-click="$ctrl.onArrowClick()"></div>\n\n        <div data-ng-if="$ctrl.loadingItems" class="typeahead_popup-placeholder typeahead_items-loading">\n          <div class="typeahead_loading-spinner" ng-style="{ \'color\': $ctrl.primaryColor }"></div>\n          <div class="typeahead_loading-label">Loading...</div>\n        </div>\n        \n        <div data-ng-if="$ctrl.noResults" class="typeahead_popup-placeholder typeahead_no-results">\n          <div class="typeahead_no-results-description">No search results found for "{{ $ctrl.currentSearchTerm }}"</div>\n          <div class="typeahead_no-results-hint">Try a different keyword or clear your search and scroll through the dropdown list.</div>\n          <div class="typeahead_no-results-clear" ng-click="$ctrl.clearSearch()">Clear Search</div>          \n        </div>\n      </div>\n    </div>\n    ',
  bindings: {
    defaultItems: '<',
    selectedItem: '<',
    fetchAction: '<',
    onItemSelected: '&',
    onScrollToBottom: '&',
    showGroupNames: '<',
    elementIndex: '@'
    // element index is for when there are multiple typeaheads in the DOM
    // and you want to specify which to open.
    // if elementIndex is undefined, it selects the first (at index 0)
  },
  controller: ["$timeout", "$document", "$scope", "scThemesService", function TypeaheadDropdownControl($timeout, $document, $scope, scThemesService) {
    var _this = this;

    var getTypeaheadInput = function getTypeaheadInput() {
      var index = _this.elementIndex ? +_this.elementIndex : 0;
      return $document.find('.typeahead_input')[index];
    };

    var getTypeaheadDropdown = function getTypeaheadDropdown() {
      return angular.element($document.find('.typeahead_input-dropdown')[0]);
    };

    this.$onInit = function () {
      _this.keepSearchTerm = false;
      _this.typeaheadOptions = { debounce: { default: 500 } };
      _this.primaryColor = _.get(scThemesService, 'active.current.styles.primaryColor', '#ccc');
      /**
       * generate uniqueId (uuid) to bind unique value to autocomplete, this will stop browser autofilling typeahead, as browser ignores autocomplete=off.
       * */
      _this.autofillValue = Math.random().toString().replace('0.', '');
      _this.registerTypeaheadOffClick();
      _this.registerTypeaheadInputKeydown();

      $timeout(function () {
        var element = $document.find('.typeahead_input-dropdown')[0];

        element.addEventListener('scroll', _this.onScroll, true);
      });
    };

    this.$onDestroy = function () {
      // unbind offclick as it is no longer needed
      $document.unbind('click', _this.offClick);
    };

    this.itemSelected = function (item, model, label) {
      _this.onItemSelected({ item: item, model: model, label: label });
      _this.closePopup();
    };

    this.executeFetchAction = function (val) {
      // set the current search term so we can display when there's no results
      if (!_this.keepSearchTerm) _this.currentSearchTerm = val;

      var forceRefresh = !_this.keepSearchTerm;

      var result = _this.fetchAction(_this.currentSearchTerm, forceRefresh);

      _this.keepSearchTerm = false;

      return result;
    };

    this.closePopup = function () {
      _this.noResults = false;
      _this.loadingItems = false;
      _this.selected = undefined;
    };

    this.focusTypeahead = function () {
      var keepSearchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.keepSearchTerm = keepSearchTerm;

      // wrapping in a setTimeout to force a separate change detection cycle tick (otherwise popup wont open)
      $timeout(function () {
        getTypeaheadInput().blur();
        getTypeaheadInput().focus();

        if (keepSearchTerm) _this.selected = _this.currentSearchTerm;
      });
    };

    this.clearSearch = function () {
      _this.selected = '';

      _this.focusTypeahead(false);
    };

    this.registerTypeaheadOffClick = function () {
      // detects clicks outside typeahead dropdown (we can technically put this behind a directive, but may be overkill for now)
      _this.offClick = function (event) {
        var clickedWithinDropdown = getTypeaheadDropdown().find(event.target).length > 0;
        if (!clickedWithinDropdown && (_this.noResults || _this.loadingItems)) {
          _this.closePopup();
        }
      };
      $document.bind('click', _this.offClick);
    };

    this.registerTypeaheadInputKeydown = function () {
      getTypeaheadInput().addEventListener('keydown', function (event) {
        if (_this.loadingItems) {
          event.preventDefault();
        } else {
          // Do nothing.
        }
      });
    };

    this.onArrowClick = function () {
      if (_this.isOpen || _this.noResults || _this.loadingItems) {
        _this.closePopup();
        return;
      }

      _this.focusTypeahead(false);
    };

    this.onScroll = function (event) {
      var element = event.target;

      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;

      // Calculate the ratio of how close to the end the scrollbar is
      var scrollRatio = scrollTop / (scrollHeight - clientHeight);

      if (scrollRatio > 0.9) {
        __debouncedScroll();
      }
    };

    var __debouncedScroll = _.debounce(function () {
      if (_this.onScrollToBottom) {
        _this.onScrollToBottom();
        _this.focusTypeahead(true);
      }
    }, 500);

    // This will clean the input if the dropdown is closed
    // by clicking outside of it.
    $scope.$watch(function () {
      return _this.isOpen;
    }, function (newValue) {
      if (!newValue) {
        _this.selected = undefined;
      }
    });
  }]
});
})();